export default function Classes() {

    const classes = [
        'ANALGESICO',
        'ANTICONVULSIVANTE',
        'ANTIDEPRESSIVO', 
        'ANTIMICROBIANO', 
        'CONVENCIONAL', 
        'CORTICOIDE', 
        'MMCDB', 
        'MMCDS', 
        'MMCDAE',
        'OPIOIDE', 
        'OSTEOMETABOLICO', 
        'SUPLEMENTO', 
        'VASOATIVO', 
        'ANTIINFLAMATORIO' 
    ]

    return classes
}